import Button from 'antd/lib/button';
import { ButtonProps } from 'antd/lib/button/button';
import { useImportContext } from '.';
import { useState } from 'react';
import { ParsedRecord } from './ImportParser';

type ImportSubmitButtonProps<T extends string> = Omit<ButtonProps, 'onClick'> & {
    onClick: (records: ParsedRecord<T>[]) => Promise<void>;
};

export const ImportSubmitButton = <T extends string>({ onClick, children, ...buttonProps }: ImportSubmitButtonProps<T>) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const {
        viewState: { records, view },
        isReadyToImport,
        onImportSubmit,
        onImportComplete,
    } = useImportContext();

    async function handleSubmit() {
        if (!records?.length) return;

        try {
            onImportSubmit();
            setIsLoading(true);
            await onClick(records);
        } catch (err) {
            console.error(err);
        } finally {
            setIsLoading(false);
            onImportComplete();
        }
    }

    return (
        <Button
            type="primary"
            onClick={handleSubmit}
            {...buttonProps}
            loading={isLoading}
            disabled={isLoading || view !== 'preview' || !isReadyToImport}
        >
            {children ? children : 'Import'}
        </Button>
    );
};
